// Talep detayında kişi/ekipman belgeleri: tıklayınca açılan liste; dosyası olan belge görüntülenebilir
import { useState } from 'react';
import { ChevronDown, ChevronRight, Eye, FileText } from 'lucide-react';
import { Badge } from '../ui/badge';
import { DocumentViewerDialog } from '../employees/DocumentViewerDialog';
import { formatDate } from '../../lib/helpers';

const STATUS = {
  onay: ['Onaylı', 'bg-emerald-100 text-emerald-700'],
  eksik: ['Eksik/Hatalı', 'bg-rose-100 text-rose-700'],
  suresi_doldu: ['Süresi Doldu', 'bg-rose-100 text-rose-700'],
  kapsam_disi: ['Kapsam Dışı', 'bg-slate-100 text-slate-500'],
};

export const PermitDocList = ({ entity, entityType = 'employees', docs, title }) => {
  const [open, setOpen] = useState(false);
  const [viewer, setViewer] = useState(null);
  const d = entity.documents || {};
  const approved = docs.filter(x => d[x.key] === 'onay').length;
  const statusOf = (key) => STATUS[d[key]] || (entity.document_files?.[key] ? ['Onay Bekliyor', 'bg-amber-100 text-amber-700'] : ['Yüklenmedi', 'bg-slate-100 text-slate-500']);

  return (
    <div className="mt-2 ml-6" data-testid={`permit-doc-list-${entity.id}`}>
      <button type="button" onClick={() => setOpen(o => !o)} className="flex items-center gap-1 text-xs font-semibold text-slate-600 hover:text-slate-900" data-testid={`permit-doc-toggle-${entity.id}`}>
        {open ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />}
        <FileText className="h-3.5 w-3.5" />Belgeler ({approved}/{docs.length} onaylı)
      </button>
      {open && (
        <div className="mt-2 divide-y rounded-md border bg-white">
          {docs.map(doc => {
            const [label, cls] = statusOf(doc.key);
            const date = d[`${doc.key}_validity`] || d[`${doc.key}_date`];
            const note = ['eksik', 'suresi_doldu'].includes(d[doc.key]) && d[`${doc.key}_note`];
            const file = entity.document_files?.[doc.key];
            return (
              <div key={doc.key} className="px-3 py-2 text-xs" data-testid={`permit-doc-row-${entity.id}-${doc.key}`}>
                <div className="flex items-center gap-2">
                  <span className="min-w-[150px] font-medium text-slate-700">{doc.label}</span>
                  <Badge className={`${cls} text-[10px]`}>{label}</Badge>
                  {date && <span className="text-slate-400">{d[`${doc.key}_validity`] ? 'Geçerlilik' : 'Tarih'}: {formatDate(date)}</span>}
                  {file && (
                    <button type="button" onClick={() => setViewer(doc)} className="ml-auto flex items-center gap-1 text-sky-700 hover:underline" data-testid={`permit-doc-view-${entity.id}-${doc.key}`}>
                      <Eye className="h-3.5 w-3.5" />Görüntüle
                    </button>
                  )}
                </div>
                {note && <p className="mt-1 break-words text-rose-600">{note}</p>}
              </div>
            );
          })}
        </div>
      )}
      <DocumentViewerDialog
        open={!!viewer} onOpenChange={(o) => !o && setViewer(null)}
        entity={entity} entityType={entityType} subtitle={title}
        docKey={viewer?.key} docLabel={viewer?.label} mode="latest"
      />
    </div>
  );
};
